import { useGetHouseContractsQuery } from "../../services/makkahGroups";
import { NUSUK_CITY_ID } from "../constants";
export const useContracts = ({ enabled = false }) => {
  const { data: contractsRes, ...rest } =
    useGetHouseContractsQuery({ enabled });

  const contracts = contractsRes?.data?.data || [];
  const makkahContracts = contracts.filter(c => String(c.city_id) === String(NUSUK_CITY_ID.makkah));
  const madinahContracts = contracts.filter(c => String(c.city_id) === String(NUSUK_CITY_ID.madina));

  return { contracts, makkahContracts, madinahContracts, ...rest };
};
